import apiClient from './api';
import type { NewsItem } from '@/types';

interface PaginatedNewsResponse {
  data: NewsItem[];
  success: boolean;
  message: string;
  total: number;
  pageNumber: number;
  pageSize: number;
}

export const newsService = {
  async getAll(page = 1, pageSize = 50, orderBy = 'Date'): Promise<NewsItem[]> {
    const response = await apiClient.get<PaginatedNewsResponse>('/news/getAll', {
      params: { pn: page, ps: pageSize, OrderBy: orderBy }
    });
    return response.data?.data || [];
  },
};
